export const sizes = {
  'heading-1': 'text-4xl',
  'heading-2': 'text-3xl',
  'title': 'text-xl',
  'body-1': 'text-lg',
  'body-2': 'text-base',
  'body-3': 'text-sm',
  'caption': 'text-xs',
  'micro': 'text-xxs'
};
